"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_MANUAL_MINUTES_PER_ORDER = exports.DEFAULT_MANUAL_MINUTES_PER_ORDER = exports.METRICS_RANGES = void 0;
exports.METRICS_RANGES = ['today', '7d', '30d'];
/** What the owner sets when the setting has never been saved. */
exports.DEFAULT_MANUAL_MINUTES_PER_ORDER = 4;
exports.MAX_MANUAL_MINUTES_PER_ORDER = 120;
//# sourceMappingURL=metrics.js.map